<template>
  <div class="profile-edit" v-loading="loading">
    <!--    <div class="balance-widget">-->
    <!--      <div class="balance-info">-->
    <!--        <div class="">-->
    <!--          <span>-->
    <!--            Ваш остаток: <strong>100 000 руб.</strong>-->
    <!--          </span>-->
    <!--        </div>-->
    <!--        <el-button @click="upBalance">Пополнить баланс</el-button>-->
    <!--      </div>-->
    <!--      <div class="change-tariff">-->
    <!--        <div></div>-->
    <!--        <span>Тарифный план <strong>Стандарт</strong></span>-->
    <!--        <div class="tariff-bottom">-->
    <!--          <a to="#">Другой траифный план <i class="fas fa-chevron-right"></i></a>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <el-form>
      <el-form-item label="Email">
        <el-input :disabled="true" v-model="form.email" placeholder="Введите Email"/>
      </el-form-item>
      <el-form-item label="Должность">
        <el-input v-model="form.position" placeholder="Введите должность"/>
      </el-form-item>
      <el-form-item label="Имя">
        <el-input v-model="form.name" placeholder="Введите имя"/>
      </el-form-item>
      <el-form-item label="Телефон">
        <el-input v-model="form.phone" placeholder="Введите телефон"/>
      </el-form-item>
      <el-form-item label="Компания">
        <el-input v-model="form.company" :disabled="form.role !== 'admin'" placeholder="Введите компания"/>
      </el-form-item>
      <a class="telegram-container"  target="_blank" :href="openTg">
        <img src="@/assets/icon/tg.svg">
        Telegram

        <div v-if="responseData">{{ responseData }}</div>
      </a>

      <el-radio-group disabled v-model="form.role">
        <el-radio label="admin">Админ</el-radio>
        <el-radio label="editor">Редактор</el-radio>
        <el-radio label="worker">Стандарт</el-radio>
      </el-radio-group>

      <el-button type="primary" class="save-btn" @click="save">Сохранить</el-button>
      <div style="margin-bottom: 20px; margin-top: 6px">
      <el-button type="danger" plain class="save-btn" @click="deleteAccount">Удалить аккаунт</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';
import PaymentProxy from '@/proxy/PaymentProxy';
import axios from "axios";
import {apiUrl} from "../../../plugins/firebase";

export default {
  name: 'ProfileEdit',

  data() {
    return {
      isCreated: null,
      responseData: null,
      loading: false,
      form: {
        position: '',
        name: '',
        email: '',
        phone: '',
        company: '',
        role: 'admin',
      },
    };
  },

  mounted() {
    try {
      const user = authFirestore.currentUser;
      user.providerData.forEach((profile) => {
        this.form.email = String(profile.email).toLowerCase().replace(/\s/g, '');
      });
    } catch (e) {
    }

    this.form.email = this.$store.state.user.email;
    setTimeout(() => {
      this.fetchUser();
    }, 500)
  },


  computed: {
    openTg() {
      return `https://d5dt1tm098j26o6ofelv.apigw.yandexcloud.net/firebaseHashTgUid?uid=${authFirestore.currentUser.uid}_mongo`
    }
  },
  methods: {
    async getTg() {
      const token = await  authFirestore.currentUser.getIdToken()
      try {
        const response = await axios.post('https://d5dt1tm098j26o6ofelv.apigw.yandexcloud.net/firebaseHashTg', {
          token: token
        });
        this.responseData = response.data;
      } catch (error) {
        console.error('Ошибка:', error);
        this.responseData = 'Произошла ошибка при получении данных';
      }
    },
    async deleteAccount() {
      this.loading = true
        this.$prompt('Ваш аккаунт нельзя будет восстановить, вы потеряете доступ ко всем проектам, для удаления введите ваш email', 'Подтвердите удаление аккаунта', {
          confirmButtonText: 'Удалить',
          cancelButtonText: 'Отменить',
          inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: 'Невалидный email'
        }).then(async ({ value }) => {
          if(value === authFirestore.currentUser.email) {
            try {
              const uid = authFirestore.currentUser.uid
              await authFirestore.currentUser.delete()

              const response = await myFirestore.collection('userStat').where({
                uid: uid
              }).get()

              let id = null

              response.forEach((subDoc) => {
                id = subDoc.id
                myFirestore.collection('userStat').doc(id).delete();
              })


              setTimeout(() => {
                window.location.reload()
              }, 1000)

            } catch (e) {
              this.$message.error('Произошла ошибка, выполните повторный вход в систему и попробуйте снова')
              this.loading = false
            }
          } else {
            this.$message.error('Для подтверждения удаления введите email вашего текущего профиля')
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
        });
    },
    fetchUser() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .where('uid', '==', authFirestore.currentUser.uid)
          .get()
          .then((data) => {
            console.log(data, 'data')
            data.forEach((subDoc) => {
              this.isCreated = subDoc.id;
              this.form = {
                ...this.form,
                ...subDoc.data(),
                role: subDoc.data().role,
              };
            });
          }).finally(() => {
          this.loading = false;
          resolve();
        }).catch(() => {
          this.loading = false;
        });
      })
    },
    async save() {
      this.loading = true;
      let path = null;
      const form = JSON.parse(JSON.stringify(this.form))
      if (this.isCreated) {
        path = myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .doc(this.isCreated)
          .update({
            ...form,
            company: this.form.company.trim()
          });
      } else {
        path = myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .add({
            uid: authFirestore.currentUser.uid,
            ...form,
            company:  this.form.company.trim()
          });
        this.isCreated = true;
      }

      path.then(() => {
        this.fetchUser();

        this.$notify({
          offset: 60,

          title: 'Успешно',
          message: 'Ваши данные изменены',
          type: 'success',
        });
        this.loading = false;
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,

          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      });
    },
    upBalance() {
      authFirestore.currentUser.getIdToken().then((idToken) => {
        const proxy = new PaymentProxy();
        proxy.getRoboUrl(idToken, {
          'company_id': 1,
          'out_sum': 1000,
        }).then(({url}) => {
          window.open(url, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.profile-edit {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 32px auto 22px auto;
}

.telegram-container {
  text-transform: none;
  text-decoration: none;
  color: #0e1011;

  display: flex;
  margin-bottom: 30px;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  font-weight: bold;
  img {
    width: 32px;
    height: 32px;
    margin-right: 10px;
    cursor: pointer;
  }
}

.balance-widget {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
}

.save-btn {
  margin-top: 32px;
  width: 100%;
  margin-bottom: 23px
}

.change-tariff {
  border: 1px solid #ccc;
  background: #f2f2f2;
  border-radius: 4px;
  padding: 10px 6px;
  margin-bottom: 20px;
  margin-top: 12px;
  height: 74px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .tariff-bottom {
    display: flex;
    justify-content: flex-end;
  }

  a {
    font-size: 12px;
    cursor: pointer;
  }
}

.balance-info {
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 764px) {
    flex-direction: column;
    align-items: flex-start;
    span {
      margin-bottom: 10px;
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Profile/Edit.vue